import { useEffect, useState } from "react";
// import axiosInstances from "../components/axiosInstance";
import axios from "axios";
import Wrapper from "../components/Wrapper";
import NotificationBar from "../components/NotificationBar";
import SmallCard from "../components/SmallCard";
import CardContainer from "../components/CardContainer";
// import DataTable from "../components/DataTable";
 
import { TbPigMoney,TbReportMoney } from "react-icons/tb";
 

const Dashboard = ()=>{
 
   
 
    const [depositsToday, setDepositsToday] = useState(0);
   
    const [payoutsToday, setPayoutsToday] = useState(0);
 
 

    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`dashboardTilesStudio`);
          
            setDepositsToday(data.deposits_today);
        
            setPayoutsToday(data.payouts_today);
          
           

        }
        )();
    },[]);
    return (
        <Wrapper pageTitle={'Dasboard'}>
            <NotificationBar />
                    <CardContainer>
                     
                        <SmallCard title={'Deposits Today'} number={depositsToday ? depositsToday: " n/a"}  icon={TbPigMoney}></SmallCard>
                          <SmallCard title={'Payouts Today'} number={payoutsToday ? payoutsToday: " n/a"}  icon={TbReportMoney}></SmallCard>  
                     
                    </CardContainer>

                    {/* <DataTable /> */}
                    


        </Wrapper>
    );
};

export default Dashboard;